<template>
  <div>
    <b-card class="bg-light-gray border-0 mt-2">
      <em class="fa fa-file-signature text-green pr-1 mr-2" />
      <b class="color">Modificar Intervenciones Adeudadas</b>
      <ValidationObserver ref="observer">
        <div class="row ml-3 mt-4">
          <div class="col-md-4">
            <label class="data-title mb-1">Intervenciones Adeudadas:</label>
            <validation-provider
               v-slot="{ errors }" 
              :custom-messages="{
                  required: 'El campo es requerido',
                  greaterThanZero: 'El número de intervenciones debe ser mayor a 0.'
                }"
                rules="required|greaterThanZero">

              <custom-input
                v-model="amount"
                :error="errors[0]"
                :custom-error-msg="errors[0]"
                :disabled="isReadOnly"
                mask-type="Number"
                style="max-width: 225px"
              />
            </validation-provider>
          </div>
          <div class="col-md-4"/>
          <div v-if="!isReadOnly" class="col-md-4">
            <div class="text-right mt-2">
              <br />
              <ActionButton
                i="fas fa-times-circle"
                variant="outline-danger btn-cancel danger ml-2"
                @click="cancel()"
              >
                Cancelar
              </ActionButton>
              <ActionButton
                variant="success ml-2 m-0  px-4"
                type="submit"
                @click="saveQuantity()"
              >
                Guardar
              </ActionButton>
            </div>
          </div>
        </div>
      </ValidationObserver>
    </b-card>
  </div>
</template>

<script>
import alert from "@/mixin/alert.mixin";
import CustomFileInput from "CustomFileInput";
import ActionButton from "ActionButton";
import CustomInput from 'CustomInput';
import _generalService from "@/services/pei/general";
export default {
  name: "ModifyCompensatoryService",
  mixins: [alert],
  components: {
    CustomFileInput,
    ActionButton,
    CustomInput
  },
  props: {
    quantity: {
      default: null
    },
    compensatoryRequestNumber:{
      default: null
    },
    isReadOnly:{
      default: null
    },
    originalQuantity: {
      default: null
    }
  },
  data() {
    return {
      amount: ""
    };
  },
  computed: {},
  mounted(){
    this.logicTosetValue();
  },
  methods: {
    async saveQuantity() {
      let isValid = await this.isValid()
      if (!isValid) {
        return;
      }
      let dataTosend = {
        preSaveInterventionAmount: parseInt(this.amount),
        compensatoryRequestNumber: this.compensatoryRequestNumber
      };
      this.$emit("save-quantity",dataTosend);
    },
    async isValid() {
      const isValid = await this.$refs.observer.validate();
      const correctQuantity = parseInt(this.amount) < parseInt(this.originalQuantity);
      if (!isValid || !correctQuantity) {
        if (!correctQuantity) {
          this.ShowToast("Alerta", "El número de intervenciones no puede ser mayor al número de las intervenciones adeudadas.","error");
        }
        return false;
      }
      return true;    
    },
    logicTosetValue(){
      if(!this.quantity) {
        this.amount = this.originalQuantity;
        return;
      }
      this.amount = this.quantity;   
    },
    cancel() {
      this.$emit("cancel-modify");
    }
  },
  watch: {
    documentFile(newValue, oldValue) {
      let dataTosend = {
        file: newValue,
        compensatoryRequestNumber: this.compensatoryRequestNumber
      };
      this.$emit("amaunt", dataTosend);
    },
    amount: {
      immediate: false,
      async handler(newValue, oldValue) {
        if(oldValue == "" ){
          return;
        }
        setTimeout(async () => {
        
          let dataTosend = {
            quantity: newValue ?? 0,
            compensatoryRequestNumber: this.compensatoryRequestNumber
          };

          let isValid = await this.isValid()
          if (!isValid) {
            return;
          }
          this.$emit("change-quantity", dataTosend);
        },500);
      }
    },

  }
};
</script>
<style lang="scss" scoped>
.color-dark-gray {
  color: #3c5044;
}
</style>
